import { frontendURL } from '../../../../helper/URLHelper';

const manuais = accountId => ({
  parentNav: 'manuais',
  routes: ['manuais_index', 'manuais_crm'],
  menuItems: [
    {
      icon: 'book',
      label: 'MANUAIS_HOME',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/manuais`),
      toStateName: 'manuais_index',
    },
    {
      icon: 'people-team',
      label: 'MANUAIS_CRM',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/manuais/crm`),
      toStateName: 'manuais_crm',
    },
  ],
});

export default manuais;
